export default __webpack_public_path__ + "static/media/invite.f06d17a7.svg";